import { render, staticRenderFns } from "./ControlFile.vue?vue&type=template&id=ccc6fa8a"
import script from "./ControlFile.vue?vue&type=script&lang=js"
export * from "./ControlFile.vue?vue&type=script&lang=js"
import style0 from "./ControlFile.vue?vue&type=style&index=0&id=ccc6fa8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports